/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useLayoutEffect, useRef, useMemo } from "react";
import { useHistory, withRouter, useLocation, useParams } from "react-router-dom";
import { observer } from "mobx-react";
import taskStoreData from "Stores/taskData";
import PerformTaskOperation from "./PerformTaskOperation";
import BreadCrumb from "Components/common/breadcrumb";
import ContactCard from "Components/ContactCard/ContactCard";
import ContactTimeline from "Pages/Dashboard/contacts/ContactTimeline/ContactTimeline";
import { ContactTimelineStore } from "Pages/Dashboard/contacts/ContactTimeline/ContactTimelineStore";
import Utils from "Utils/utils";
import IconType from "Pages/Dashboard/contacts/ContactTimeline/IconType";
import NavTaskButton from "./NavTaskButton";
import { useCopilotContext } from "Pages/Dashboard/Copilot/agent/copilotContext";
import usePageFindings from "Pages/Dashboard/Copilot/agent/usePageFindings";
import performTaskFindings from "./performTaskFindings";
import copilotStore from "Stores/copilotStore";
import copilotDrawerStore from "Stores/copilotDrawerStore";
import powerDialerStore from "Stores/powerDialerStore";
import PowerDialerDock from "Components/PowerDialer/PowerDialerDock";
import userDetail from "Stores/userDetail";
import { makeApi, URLS } from "Utils/apiURL";

const PerformTaskComponent = ({ }) => {
  const breadcrumbArr = [{ name: "Tasks", link: "/tasks" }];
  const [taskListState, setTaskListState] = useState([]);
  const [selectedTask, setSelectedTask] = useState({});
  const [contactData, setContactData] = useState("");
  const [selectedTaskNumber, setSelectedTaskNumber] = useState(
    localStorage.getItem("selectedTaskNo") || 1
  );
  const [loading, setLoading] = useState(true);
  const [isNextBtnEnabled, setNextBtnEnabled] = useState(true);
  const [isPreviousBtnEnabled, setIsPreviousBtnEnabled] = useState(true);
  const [taskLoading, setTaskLoading] = useState(false);
  const [contactCardLoader, setContactCardLoader] = useState(false);
  const [timelineLoader, setTimelineLoader] = useState(false);
  const [triggerTimeline, setTriggerTimeline] = useState(false);
  const [taskDetails, setTaskDetails] = useState({});

  const location = useLocation();
  const history = useHistory();
  const { id: paramTaskId } = useParams();
  const isPowerMode =
    new URLSearchParams(location.search).get("mode") === "power" &&
    !userDetail?.featuresDisabled?.includes("POWER_DIALER");

  // ContactCard mounts as part of this same render and fires its own mount
  // effect (getContactStage) in a useEffect. React runs ALL useLayoutEffects
  // for the whole tree before running ANY useEffect, so dispatching the
  // getTask request here (instead of useEffect, and instead of unsafely
  // mutating store state during render) guarantees it goes out before
  // ContactCard's passive effect, without the render-purity issues of
  // firing it directly in the render body.
  const taskDetailPromiseRef = useRef(null);
  useLayoutEffect(() => {
    if (!taskDetailPromiseRef.current && paramTaskId && !isPowerMode) {
      taskStoreData.setCurrentTaskId(paramTaskId);
      taskDetailPromiseRef.current = taskStoreData.getPerformTaskData("", null, selectedTaskNumber, null, false, 1, taskStoreData?.dateFilterValue, taskStoreData?.statusFilterValue, "", true);
    }
  }, []);

  const constructTaskList = (
    taskDataFromStore,
    isPrevOrNextEnabled = false
  ) => {
    if (taskDataFromStore?.tasks) {
      const tasksArr = taskDataFromStore?.tasks || [];
      const renderData = [];
      tasksArr.map((taskObj, index) => {
        if (taskObj) {
          const contactObj = taskObj?.contact || {};
          const {
            company,
            email,
            firstName,
            lastName,
            phone,
            mobilePhone,
            jobTitle,
            linkedinUrl,
            linkedinId,
            stage
          } = contactObj;
          const customFieldData = {};
          for (let i = 1; i <= 30; i++) {
            const key = `customField${i}`;
            if (contactObj[key] !== undefined) customFieldData[key] = contactObj[key];
          }
          const {
            sequenceEmail = false,
            inboxId = "",
            fromAddress = ""
          } = taskObj || {};
          setTaskDetails({
            sequenceEmail,
            inboxId,
            existingfromAddress: fromAddress
          });
          const signature = taskObj?.signature || "";
          let {
            id,
            customTask,
            note = "",
            taskDue,
            taskType = "",
            linkedInTaskType,
            contactId,
            status,
            content = "",
            subject = "",
            eligibleToSkipStage = false,
            trackerId = "",
            attachments = [],
            sequenceId = ""
          } = taskObj?.task || {};

          if (
            taskObj?.task?.touchPoint &&
            Object.keys(taskObj.task.touchPoint).length > 0
          ) {
            const { notes = "", type = "" } = taskObj.task.touchPoint || {};
            note = notes;
            taskType = type;
            content = taskObj?.task?.touchPoint?.content || "";
            subject = taskObj?.task?.touchPoint?.subject || "";
            attachments = taskObj?.task?.touchPoint?.attachments || [];
            linkedInTaskType =
              taskObj?.task?.touchPoint?.linkedInTaskType || "";
            trackerId = taskObj?.task?.touchPoint?.trackerId || "";
          }
          const tempObj = {
            ...customFieldData,
            id,
            note,
            customTask,
            taskDue,
            taskType,
            jobTitle,
            status,
            stage,
            linkedinUrl,
            linkedInTaskType,
            linkedinId,
            firstName,
            email,
            contactId,
            company,
            lastName,
            phone,
            mobilePhone,
            subject,
            content,
            eligibleToSkipStage,
            trackerId,
            fromAddress,
            signature,
            attachments,
            sequenceId
          };
          renderData.push(tempObj);
        }
      });
      if (isPrevOrNextEnabled) {
        return renderData;
      } else {
        setTaskListState(renderData);
        setLoadingFn(false);
      }
    }
  };

  const setLoadingFn = value => {
    setLoading(value);
  };

  const getTaskStatus = (status = "", taskDue = "", id = "") => {
    let tempStatus = status?.toLowerCase();
    if (["completed", "skipped"].includes(tempStatus)) {
      return (
        <div className="completedBtn">
          <i className="material-icons tickIcon">check</i>
          <span className="statusCont">{tempStatus}</span>
        </div>
      );
    } else {
      let tempTaskDue = Utils.getDueDateToRender(taskDue);
      return (
        <span
          className="taskDue"
          id={`taskdue${id}`}
          style={{ color: tempTaskDue?.color }}
        >
          {tempTaskDue?.dueDate}
        </span>
      );
    }
  };

  const fetchNextOrPrevTaskId = (taskNumber = "") => {
    if (taskStoreData?.taskIds?.length) {
      if (+taskNumber >= 1 && +taskNumber <= taskStoreData?.taskIds?.length) {
        if (+taskNumber >= taskStoreData?.taskIds?.length) {
          setNextBtnEnabled(false);
          setIsPreviousBtnEnabled(true);
        } else if (+taskNumber === 1) {
          setNextBtnEnabled(true);
          setIsPreviousBtnEnabled(false);
        }
        taskStoreData.setCurrentTaskId(
          taskStoreData?.taskIds?.[+taskNumber - 1]
        );
      }
    }
  };

  const showTask = async (showText = "", taskNum = 1, isLazyload = false) => {
    let taskNumber =
      showText === "complete"
        ? +selectedTaskNumber + 1
        : showText === "next"
          ? +selectedTaskNumber + 1
          : showText === "previous"
            ? +selectedTaskNumber - 1
            : taskNum || selectedTaskNumber || 1;
    if (["previous", "next", "complete"].includes(showText?.toLowerCase())) {
      if (+taskNumber <= taskStoreData?.totalTasks && +taskNumber >= 1)
        setSelectedTaskNumber(taskNumber);
    }
    fetchNextOrPrevTaskId(taskNumber);
    const dateFilterValue = taskStoreData?.dateFilterValue;
    const statusFilterValue = taskStoreData?.statusFilterValue;
    setContactCardLoader(true);
    setTimelineLoader(true);
    setTaskLoading(true);
    await taskStoreData.getPerformTaskData(
      "",
      null,
      taskNumber,
      null,
      isLazyload,
      1,
      dateFilterValue,
      statusFilterValue,
      showText,
      true
    );
    let tempTaskData = constructTaskList(taskStoreData.taskData, true);
    if (tempTaskData?.length > 0) {
      setSelectedTask(tempTaskData[0]);
      setContactData(tempTaskData[0]);
      setTriggerTimeline(true);
      tempTaskData?.[0]?.id && history.push(`${tempTaskData[0]?.id}${location.search}`);
      taskStoreData.setCurrentTaskId(tempTaskData[0]?.id);
    } else if (tempTaskData?.length === 0) {
      showTask("", taskStoreData?.totalTasks);
      setSelectedTaskNumber(taskStoreData?.totalTasks);
      setNextBtnEnabled(false);
    }
    setLoadingFn(false);
    setTaskLoading(false);
  };

  const loadTaskDetailById = async (taskId = "") => {
    const dateFilterValue = taskStoreData?.dateFilterValue;
    const statusFilterValue = taskStoreData?.statusFilterValue;
    setContactCardLoader(true);
    setTimelineLoader(true);
    setTaskLoading(true);
    if (taskDetailPromiseRef.current) {
      await taskDetailPromiseRef.current;
      taskDetailPromiseRef.current = null;
    } else {
      taskStoreData.setCurrentTaskId(taskId);
      await taskStoreData.getPerformTaskData("", null, selectedTaskNumber, null, false, 1, dateFilterValue, statusFilterValue, "", true);
    }
    let tempTaskData = constructTaskList(taskStoreData.taskData, true);
    if (tempTaskData?.length > 0) {
      setSelectedTask(tempTaskData[0]);
      setContactData(tempTaskData[0]);
      setTriggerTimeline(true);
      taskStoreData.setCurrentTaskId(tempTaskData[0]?.id);
    }
    setLoadingFn(false);
    setTaskLoading(false);
  };

  const fetchPerformTaskData = async () => {
    const dateFilterValue = taskStoreData?.dateFilterValue;
    const statusFilterValue = taskStoreData?.statusFilterValue;
    await taskStoreData.getTaskIdsFromSelectedPage("", null, "", null, "", 1, dateFilterValue, statusFilterValue, "", true);
  };

  const setSelectedTaskFn = (navigationType = "") => {
    if (navigationType === "complete") {
      showTask("complete");
      taskStoreData.setUpdatedFromAddressObj({});
    } else if (navigationType === "next") {
      showTask("next");
      taskStoreData.setUpdatedFromAddressObj({});
    } else if (navigationType === "previous") {
      showTask("previous");
      taskStoreData.setUpdatedFromAddressObj({});
    } else if (location?.state?.key) {
      setTaskLoading(true);
      fetchPerformTaskData();
      let tempTaskNumber =
        (taskStoreData?.selectedTaskPage - 1) * 20 + location?.state?.key;
      showTask("", tempTaskNumber);
      setSelectedTaskNumber(tempTaskNumber);
      if (tempTaskNumber === taskStoreData?.totalTasks) {
        setNextBtnEnabled(false);
      }
    } else {
      showTask("", 1);
    }
  };

  const reloadTaskPage = () => {
    taskStoreData.getPerformTaskData(
      "",
      null,
      selectedTaskNumber,
      null,
      false,
      1
    );
  };

  const markSelectedTaskFn = (currentTaskId, inputValue) => {
    taskListState.map(value => {
      if (value?.id === currentTaskId) {
        value.status = "COMPLETED";
        if (inputValue?.subject) {
          value.subject = inputValue.subject;
        }
        if (inputValue?.bodyContent) {
          value.bodyContent = inputValue.bodyContent;
        }
        if (inputValue?.attachments?.length) {
          value.attachments = inputValue.attachments;
        }
      }
      return taskListState;
    });
    const temp = taskStoreData.taskData;
    temp?.tasks?.length > 0 &&
      temp.tasks.map(item => {
        if (item?.task?.id === currentTaskId) {
          item.task.status = "COMPLETED";
          if (inputValue?.bodyContent) {
            item.task.touchPoint = { content: inputValue?.bodyContent };
          }
        }
        return temp;
      });
    taskStoreData.setTaskData(temp);
    setTaskListState(taskListState);
    setSelectedTask({
      ...selectedTask,
      content: inputValue?.bodyContent,
      subject: inputValue?.subject,
      attachments: inputValue?.attachments,
      status: "COMPLETED"
    });
  };

  const markSkippedTaskFn = (currentTaskId, inputValue) => {
    taskListState.map(value => {
      if (value && value.id === currentTaskId) {
        value.status = "SKIPPED";
      }
      return taskListState;
    });
    setTaskListState(taskListState);
  };

  const checkPrevAndNextEnabled = () => {
    if (selectedTaskNumber === 1 && taskStoreData?.totalTasks === 1) {
      setIsPreviousBtnEnabled(false);
      setNextBtnEnabled(false);
    } else if (selectedTaskNumber === 1) {
      setIsPreviousBtnEnabled(false);
      setNextBtnEnabled(true);
    } else if (selectedTaskNumber >= taskStoreData?.totalTasks) {
      setNextBtnEnabled(false);
      setIsPreviousBtnEnabled(true);
    } else {
      setIsPreviousBtnEnabled(true);
      setNextBtnEnabled(true);
    }
  };

  const getTaskType = () => {
    return ["linkedin", "phone", "email", "customtask"].includes(
      selectedTask?.taskType?.toLowerCase() || ""
    )
      ? selectedTask?.taskType
      : selectedTask?.taskType?.toLowerCase() === "manualemail"
        ? "email"
        : false;
  };

  const getTaskName = () => {
    return ["customtask"].includes(selectedTask?.taskType?.toLowerCase())
      ? "Custom Task"
      : selectedTask?.taskType;
  };

  const reloadPerformTask = (keyType = "", obj = {}) => {
    ContactTimelineStore.setReloadTaskTimelineActivity(true);
    if (
      selectedTask?.contactId === obj?.contactId &&
      (selectedTask?.sequenceId === obj?.sequenceId ||
        selectedTask?.sequenceId === obj?.scheduledSeqId) &&
      ["PAUSED", "PAUSED_OOTO", "REMOVED", "SKIP", "COMPLETED"]?.includes(
        keyType?.toUpperCase()
      )
    ) {
      setSelectedTaskFn(isNextBtnEnabled ? "next" : "");
    }
  };

  useEffect(() => {
    localStorage.setItem("selectedTaskNo", selectedTaskNumber);
  }, [selectedTaskNumber]);

  const backToTaskPage = () => {
    taskStoreData.setResetState();
    history.push("/tasks");
  };

  useEffect(() => {
    localStorage.setItem("selectedTaskNo", selectedTaskNumber);
  }, [selectedTaskNumber]);

  useEffect(() => {
    checkPrevAndNextEnabled();
  }, [selectedTaskNumber, taskStoreData?.totalTasks]);

  const askCopilot = text => {
    copilotStore.setPendingAutoSend(text);
    copilotDrawerStore.openFor("tasks", selectedTask?.id || "");
  };

  useCopilotContext(
    "tasks",
    () => ({
      entity: selectedTask?.id ? { type: "task", id: selectedTask.id } : undefined,
      viewState: { taskType: selectedTask?.taskType }
    }),
    !!selectedTask?.id
  );

  const performTaskCopilotFindings = useMemo(
    () =>
      performTaskFindings({
        taskType: selectedTask?.taskType,
        linkedInTaskType: selectedTask?.linkedInTaskType,
        contactStage: selectedTask?.stage
      }).map(finding => {
        if (finding.key === "draft_email") {
          return { ...finding, actions: [{ label: "Draft it", run: () => askCopilot("Draft this email for the current task using the thread and the contact's research. Show me, do not send.") }] };
        }
        if (finding.key === "call_brief") {
          return { ...finding, actions: [{ label: "Get brief", run: () => askCopilot("Give me a five-line pre-call brief for this contact: last touch, what they opened or clicked, company news, one objection to expect, and an opener.") }] };
        }
        if (finding.key === "linkedin_note") {
          return { ...finding, actions: [{ label: "Write note", run: () => askCopilot("Write a LinkedIn connection note under 300 characters for this contact. One reason to connect, no pitch.") }] };
        }
        if (finding.key === "blocked_contact") {
          return { ...finding, actions: [{ label: "Skip it", run: () => askCopilot("Skip this task, the contact is blocked. Confirm first.") }] };
        }
        if (finding.key === "recent_reply") {
          return { ...finding, actions: [{ label: "Go to inbox", run: () => history.push("/inbox") }] };
        }
        return finding;
      }),
    [selectedTask?.taskType, selectedTask?.linkedInTaskType, selectedTask?.stage, selectedTask?.id]
  );

  usePageFindings(performTaskCopilotFindings, "perform_task");

  useEffect(() => {
    const initFn = async () => {
      if (isPowerMode) {
        // The power-mode effect above loads the dock's current task.
        return;
      }
      if (paramTaskId) {
        // Fire the task detail fetch immediately - it only needs the taskId from the URL
        const detailPromise = loadTaskDetailById(paramTaskId);
        const idsPromise =
          taskStoreData?.taskIds?.length === 0
            ? fetchPerformTaskData()
            : Promise.resolve();

        await detailPromise;
        await idsPromise;

        const taskIndex =
          taskStoreData?.taskIds?.length > 0
            ? taskStoreData.taskIds.indexOf(paramTaskId)
            : -1;

        if (taskIndex > -1) {
          setSelectedTaskNumber(taskIndex + 1);
        } else {
          // Task not in the current list (e.g. different filter default)
          setNextBtnEnabled(false);
          setIsPreviousBtnEnabled(false);
        }
      } else {
        await fetchPerformTaskData();
        setSelectedTaskFn();
      }
    };

    initFn();

    return () => {
      taskStoreData.setResetState();
      taskStoreData.setTaskAttachments([]);
    };
  }, []);

  // Power mode: the page shows only the dock's current call (or the first dialable task before
  // dialing). Fetched on its own -- not through taskStoreData's shared, cancellable request -- and a
  // response is dropped once a newer task is current, so a slow fetch can't paint an older contact.
  const focusTaskId = isPowerMode ? powerDialerStore.focusTaskId || paramTaskId : "";
  useEffect(() => {
    if (!focusTaskId) return;
    let stale = false;
    history.replace(`/tasks/start/${focusTaskId}${location.search}`);
    taskStoreData.setCurrentTaskId(focusTaskId);
    setContactCardLoader(true);
    setTimelineLoader(true);
    setTaskLoading(true);
    makeApi({ url: URLS.getPerformTaskData.replace("<<taskId>>", focusTaskId) })
      .then(res => {
        if (stale) return;
        const list = constructTaskList({ tasks: res?.data?.tasks || [] }, true);
        if (list?.[0]) {
          setSelectedTask(list[0]);
          setContactData(list[0]);
          setTriggerTimeline(true);
        }
      })
      .catch(() => {})
      .finally(() => {
        if (stale) return;
        setLoadingFn(false);
        setTaskLoading(false);
      });
    return () => {
      stale = true;
    };
  }, [focusTaskId]);

  const taskHeaderLoader = () => {
    return (
      <>
        <div className="detailedTaskInfo">
          <div className="detailedTaskInfoLoader">
            <div className="iconLoader linear-background" />
            <div className="taskTypeLoader linear-background" />
            <div className="taskDueLoader linear-background" />
          </div>
        </div>
        <div className="navigationAndTaskCount">
          <div className="numberOfTaskCont linear-background" />
          <div className="navTaskBtnCont">
            <div className="navToPrev linear-background" />
            <div className="navToNext linear-background" />
          </div>
        </div>
      </>
    );
  };

  return (
    <div className={`performTask pageClass ${isPowerMode ? "pdPowerMode" : ""}`}>
      <div className="performTaskCont pageCont">
        <section className="headerSection">
          <BreadCrumb breadCrumbValue={breadcrumbArr} />
        </section>

        <section className="taskSection pageLayout">
          <div className="contentLayout">
            <div className="performTaskPanel">
              <div className="taskHeaderSection">
                <BackToTaskPage backToTaskPage={backToTaskPage} />
                <div className="taskDetailNavHeader">
                  {loading && taskHeaderLoader()}
                  {!loading && (
                    <>
                      <div className="detailedTaskInfo">
                        <div className="taskTypeWithIcon">
                          <IconType taskType={getTaskType()} />
                          <div className="taskName">{getTaskName()}</div>
                        </div>
                        {getTaskStatus(
                          selectedTask?.status,
                          selectedTask?.taskDue,
                          selectedTask?.id
                        )}
                        {isPowerMode && selectedTask?.note && (
                          <span className="pdTaskNote">· Task note: {selectedTask.note}</span>
                        )}
                      </div>
                      {isPowerMode && <PowerDialerBadge />}
                      {!isPowerMode && <div className="navigationAndTaskCount">
                        <div className="numberOfTaskCont">
                          <div className="selectedTaskNumber">
                            {selectedTaskNumber || 1}
                            &nbsp;of&nbsp;
                          </div>
                          <div className="totalTask">
                            {taskStoreData?.totalTasks || 1}&nbsp;
                            {taskStoreData?.totalTasks > 1 ? "Tasks" : "Task"}
                          </div>
                        </div>
                        <NavTaskButton
                          setSelectedTaskFn={setSelectedTaskFn}
                          isPreviousBtnEnabled={isPreviousBtnEnabled}
                          isNextBtnEnabled={isNextBtnEnabled}
                          id={selectedTask?.id}
                          pageType="PERFORM_TASK"
                          taskType={selectedTask?.taskType?.toLowerCase()}
                        />
                      </div>}
                    </>
                  )}
                </div>
              </div>
              <div className="taskBody">
                <ContactCard
                  contact={{
                    id: selectedTask?.contactId || contactData?.contactId
                  }}
                  reloadTaskPage={true}
                  isContactSlider={false}
                  handleSuccessCallback={reloadTaskPage}
                  contactCardLoader={contactCardLoader}
                  setContactCardLoader={setContactCardLoader}
                  setTriggerTimeline={setTriggerTimeline}
                  pageType="performTask"
                  cardType="perform_task"
                  isReloadCbk={reloadPerformTask}
                  triggerContactCard={triggerTimeline}
                  isFromPerformTask={true}
                />
                <ContactTimeline
                  isTaskPage={true}
                  contactIdFromTaskPage={
                    selectedTask?.contactId || contactData?.contactId
                  }
                  timelineLoader={timelineLoader}
                  setTimelineLoader={setTimelineLoader}
                  triggerTimeline={triggerTimeline}
                  setTriggerTimeline={setTriggerTimeline}
                />
                {!isPowerMode && <PerformTaskOperation
                  data={selectedTask}
                  loading={loading}
                  taskLoading={taskLoading}
                  setSelectedTaskFn={setSelectedTaskFn}
                  markSelectedTaskFn={markSelectedTaskFn}
                  markSkippedTaskFn={markSkippedTaskFn}
                  selectedTaskNumber={selectedTaskNumber}
                  isNextBtnEnabled={isNextBtnEnabled}
                  isPreviousBtnEnabled={isPreviousBtnEnabled}
                  setTaskLoading={setTaskLoading}
                  taskDetails={taskDetails}
                />}
              </div>
            </div>
          </div>
        </section>
      </div>
      {isPowerMode && <PowerDialerDock taskIds={powerDialerStore.taskIds} />}
    </div>
  );
};

const PowerDialerBadge = observer(() => {
  const { state, callNumber, dialableCount } = powerDialerStore;
  const label =
    !state || state === "start" ? "ready" : state === "done" ? "done" : `call ${Math.max(callNumber, 1)} of ${dialableCount}`;
  return <span className="pdBadge">Power dialer · {label}</span>;
});

const BackToTaskPage = ({ backToTaskPage = () => { } }) => {
  return (
    <div className="backButton">
      <span className="backIconToolTipWrapper" onClick={backToTaskPage}>
        <i className="material-icons">keyboard_backspace</i>
      </span>
    </div>
  );
};

export default withRouter(observer(PerformTaskComponent));
export { PerformTaskComponent };
